import { useCallback, useEffect, useState } from "react"
import api, { operation } from "../services/axios";
type BancosType = {
    [key: string]: string;
}
export const useBancos = () => {
    const [bancos, setBancos] = useState({} as BancosType)
    const [ispb, setIspb] = useState({} as BancosType)

    const getBancos = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                const { data } = await api.get('/backoffice/obter/bancos')
                setBancos(data.compe2)
                setIspb(data.compeToIspb)
            } catch (error) {
                
            }
        });
    }, [])

    useEffect(() => {
        getBancos()
    }, [getBancos])

    function getIspb(compe: keyof typeof ispb) {
        if(!ispb[compe]) {
            return ''
        }
        
        return ispb[compe]
    }

    return {
        bancos,
        getIspb
    }
}
